import React, { useEffect, useState } from "react";
import NavMobile from "./components/NavMobile";
import NavDesktop from "./components/NavDesktop";
import logo from "../../images/logo_largo_blanco.png";
import { FiMenu } from "react-icons/fi";
import { Button } from "@fluentui/react-components";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import CustomIcon from "../Icons/CustomIcon";
import "./Layout.css";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { GenerateImageContext } from "../../context/GenerateImageContext";

const Layout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const {resetImageGenerate} = React.useContext(GenerateImageContext);
  const location = useLocation();
  const handleMenuToggle = () => {
    setIsMenuOpen((prevIsMenuOpen) => !prevIsMenuOpen);
  };
  const { updateAccountInfo } = React.useContext(AuthContext);

  useEffect(() => {
    ReactGA.send({hitType:"pageview", page:location.pathname,title:"navigate user"})
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
      updateAccountInfo({
        userName: process.env.REACT_APP_USER_EMAIL,
        accountIdentifier: process.env.REACT_APP_USER_EMAIL,
        userEmail:process.env.REACT_APP_USER_EMAIL,
      });
  }, []);

  

  return (
      <div
        style={{
          height: "100svh",
          display: "flex",
          maxWidth: "100%",
          flexDirection: "column",
        }}
      >
        <nav className={`navbar ${isMenuOpen ? "open" : ""}`}>
          <div className="navbar-left">
            <button className="menu-icon" onClick={handleMenuToggle}>
              <FiMenu />
            </button>
          </div>
          <div className="navbar-center">
          <Link to='/generate' onClick={resetImageGenerate}>
              <img className="img-navbar-center" src={logo} alt="Logo" />
          </Link>
          </div>
          <NavDesktop />
          <div className={`navbar-menu ${isMenuOpen ? "open" : ""}`}>
            <div
              style={{
                textAlign: "left",
                margin: "5px",
              }}
            >
              <Button
                className="close-icon"
                onClick={handleMenuToggle}
                appearance="subtle"
                icon={<CustomIcon type="close" />}
                aria-label="Cerrar"
                size="small"
              />
            </div>
            <NavMobile />
          </div>
          <div>
            
          </div>
        </nav>
        <main
          style={{
            textAlign: "center",
            height: "100%",
            overflow: "auto",
            backgroundColor: "black",
            maxHeight: "100vh",
          }}
        >
          {children}
        </main>
      </div>
  );
};

export default Layout;
